import { atom, useAtom } from "jotai";

import { TradeDirection } from "#/types/trade";

export const tradeDirectionAtom = atom<TradeDirection>("buy");

export const useTradeDirection = () => {
  const [tradeDirection, setTradeDirection] = useAtom(tradeDirectionAtom);

  return {
    tradeDirection,
    setTradeDirection,
  };
};
